import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Alert from "../../Components/alert/Alert";
import {handleColor} from '../../services/Functions'
import ReportDepartaments from "../Reports/reportDepartaments";
import AddUser from "../Registration/Users/addUser";
import AltUser from "../Registration/Users/altUser";
import DelUser from "../Registration/Users/delUser";
import Users from "../Reports/reportUsers";
import ConfigView from "../Config/configView";
import "./prelude.css";

class PreludeParameters extends React.Component {
  render() {
    return (
      <>
        <header>
          <Top_bar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { render: false, message: "", click: false };

  async componentWillMount() {
      let viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", viewport.content + ", height=" + window.innerHeight);
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

 

  render() {
    const { show, message } = this.state;

    return (
      <Tab.Container defaultActiveKey="times">
        <Row style={{width:'100%',height:'100%'}}>
          <div className="sidebar1 ">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="times"
                  >
                    {'Configurações'}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "5%", marginLeft: "1.5%", height:'78vh' ,width: "100%", overflow:'auto' }}>
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="times">
                {this.handleClick ? <ConfigView /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default PreludeParameters;